import React from 'react';
import { formatCurrencyStyled } from '../visuals/currency.formatted';

import './numberDisplay.scss';

export interface NumberDisplayDetail {
    label: string;
    value: number;
    icon?: 'arrow_upward' | 'arrow_downward' | 'arrow_forward' | 'warning' | 'account_balance';
    coloring?: 'green' | 'gray' | 'red' | 'orange';
}

interface NumberDisplayProps {
    title: string;
    value: number;
    icon?: 'arrow_upward' | 'arrow_downward' | 'arrow_forward' | 'warning' | 'account_balance';
    coloring: 'green' | 'gray' | 'red' | 'orange';
    addClass?: string;
    details?: NumberDisplayDetail[];
}

function NumberDisplay({ title, addClass = '', value, coloring = 'gray', icon, details }: NumberDisplayProps) {

    return (
        <div className={`_numberDisplay ${addClass} ${!icon ? '_noIcon' : ''}`}>
            <div className="main">
                <div className="text">
                    <h2>
                        {formatCurrencyStyled(value || 0)}
                    </h2>
                    <p>{title}</p>
                </div>
                {
                    icon ?
                        <div className={`icon ${coloring ? coloring : ''} ${icon === 'warning' ? 'noBold' : ''}`}>
                            <span className="material-icons">
                                {icon}
                            </span>
                        </div>
                        : null
                }
            </div>
            {!!details?.length && (
                <div className="details">
                    {details.map((d, i) => (
                        <div className="detailRow" key={i}>
                            <span className="detailLabel">{d.label}</span>
                            <span className="detailValue">
                                {formatCurrencyStyled(d.value)}
                            </span>
                            {d.icon && (
                                <span className={`material-icons detailIcon ${d.coloring || ''}`}>
                                    {d.icon}
                                </span>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default NumberDisplay;
